import {useEffect} from 'react';
import {isClickOutsideExcludedTarget} from '../utils/clickOutsideExcludedSelectors';

let onClickOutsideStatus = true;

export const updateOnClickOutsideStatus = (status) => {
    onClickOutsideStatus = status;
};

const useOnClickOutside = (ref, handler, condition = true) => {
    useEffect(
        () => {
            if(!condition) {
                return;
            }

            const listener = (event) => {
                if(!ref.current || ref.current.contains(event.target)) {
                    return;
                }
                if(isClickOutsideExcludedTarget(event.target)) {
                    return;
                }
                if(onClickOutsideStatus) {
                    handler(event);
                }
            };
            document.addEventListener('click', listener);
            return () => {
                document.removeEventListener('click', listener);
            };
        },
        [ref, handler, condition]
    );
};

export default useOnClickOutside;
